// TODO: use reset instead of setValue?
import { useContext, useEffect } from 'react'
import { DEFAULT_COLOR } from '../config/defaults'
import { FieldValues, UseFormSetValue } from 'react-hook-form'
import { StoreSettingsContext } from 'store'
import { dataURLtoFile, getBase64FromUrl } from 'features/settings/utils/utils'

type UsePopulateSettingsProps = {
	setValue: UseFormSetValue<FieldValues>
	setAccentColor: (color: string) => void
}

export const usePopulateSettings = ({ setValue, setAccentColor }: UsePopulateSettingsProps) => {
	const storeCtx = useContext(StoreSettingsContext)

	useEffect(() => {
		const fields = [
			'name',
			'website_url',
			'phone',
			'email',
			'default_from_email',
			'legal_name',
			'legal_id',
			'terms_of_service_url',
			'facebook_url',
			'twitter_url',
			'instagram_url',
			'pinterest_url',
			'linkedin_url',
			'payment_receipt_url',
			'payment_cancel_url',
			'rapyd_access_key',
			'rapyd_secret_key',
			'rapyd_sandbox',
			'quantity_enabled',
			'categories_enabled',
			'color_enabled',
			'tags_enabled',
			'coupons_enabled',
			'enabled_payout_methods',
			'photos_required_to_publish',
			'cost_price_enabled',
			'users_can_publish_products',
			'netgiro_app_id',
			'netgiro_secret_key',
			'netgiro_sandbox',
			'default_product_publish_value',
			'sendgrid_end_reminder_template_id',
			'sendgrid_receipt_template_id',
			'sendgrid_welcome_template_id',
			'start_reminder_sms_template',
			'end_reminder_sms_template',
			'sendgrid_payout_method_reminder_template_id',
			'resalex_client_id',
			'resalex_client_secret',
			'resalex_sandbox',
			'product_conditions_enabled',
			'product_fabrics_enabled',
			'product_genders_enabled',
			'product_types_enabled',
			'supplier_sku_barcode_enabled',
			'vat_enabled',
			'product_confirm_enabled'
		]

		fields.forEach((field) => setValue(field, storeCtx?.storeSettings?.[field]))

		setValue('address.address', storeCtx?.storeSettings?.address?.address)
		setValue('address.postal_code', storeCtx?.storeSettings?.address?.postal_code)
		setValue('address.city', storeCtx?.storeSettings?.address?.city)
		setValue('legal_address.address', storeCtx?.storeSettings?.legal_address?.address)
		setValue('legal_address.postal_code', storeCtx?.storeSettings?.legal_address?.postal_code)
		setValue('legal_address.city', storeCtx?.storeSettings?.legal_address?.city)
		setValue(
			'booking_fees.product_storage_max_days',
			storeCtx?.storeSettings?.booking_fees?.product_storage_max_days
		)
		setValue(
			'booking_fees.booth_takedown_fee',
			storeCtx?.storeSettings?.booking_fees?.booth_takedown_fee
		)
		setValue(
			'booking_fees.booth_takedown_fee_notified',
			storeCtx?.storeSettings?.booking_fees?.booth_takedown_fee_notified
		)
		setValue(
			'booking_fees.product_storage_fee_per_day',
			storeCtx?.storeSettings?.booking_fees?.product_storage_fee_per_day
		)

		setAccentColor(storeCtx?.primaryColor || DEFAULT_COLOR)

		if (storeCtx?.storeSettings?.logo) {
			fetch(storeCtx?.storeSettings?.logo).then((res) => {
				const name = res.url.split('/').pop()

				getBase64FromUrl(res.url).then((res) =>
					setValue('logo', dataURLtoFile(res as string, name!))
				)
			})
		}
	}, [storeCtx?.storeSettings])
}
